import React from 'react';

import { SVGPropsType } from 'src/types';

function SortDown(props: SVGPropsType) {
    const { fill, onClick, style, className } = props;

    return (
        <svg
            width="6"
            height="4"
            viewBox="0 0 6 4"
            fill="none"
            xmlns="http://www.w3.org/2000/svg"
            onClick={onClick}
            style={style}
            className={className}
        >
            <path
                d="M0.705063 0.923401L2.65713 2.73526C2.84974 2.91395 3.15041 2.91395 3.34301 2.73526L5.29508 0.923401L6.00003 1.57917L3.68685 3.73102C3.30148 4.08956 2.69881 4.08956 2.31343 3.73102L0.000244141 1.57917L0.705063 0.923401Z"
                fill={fill}
            />
        </svg>
    );
}

export default SortDown;
